export enum ErrorMessageEnum {
  DEFAULT = 'เกิดข้อผิดพลาดที่ไม่คาดคิด',
  BAD_REQUEST = 'คำขอไม่ถูกต้อง',
  UNAUTHORIZED = 'ไม่มีสิทธิ์เข้าถึง',
  FORBIDDEN = 'ไม่ได้รับอนุญาตให้เข้าถึง',
  NOT_FOUND = 'ไม่พบข้อมูลที่ต้องการ',
  INTERNAL_SERVER = 'เกิดข้อผิดพลาดภายในเซิร์ฟเวอร์',
  USER_DUPLICATED = 'ข้อมูลซ้ำ'
}
